/**
 * CaterCraft — static catalog (easy to swap for API later).
 * Change APP_BRAND for white-label.
 */
export const APP_BRAND = {
  name: 'CaterCraft',
  tagline: 'Design your perfect feast — per-plate & bulk pricing in one place',
  subline: 'Shubh avsar · With love for your celebration'
};

export const CATEGORY_ORDER = [
  'Starters / Appetizers',
  'Soups',
  'Main Course (Veg)',
  'Main Course (Non-Veg)',
  'Breads / Rice / Biryani',
  'Accompaniments',
  'Desserts',
  'Beverages / Welcome Drinks',
  'Live Counters'
];

export const FOOD_ITEMS = [
  // Starters
  { id: 'st01', name: 'Veg Spring Roll', category: 'Starters / Appetizers', pricePerPlate: 38, isVeg: true, description: 'Crisp rolls with cabbage & carrot', tags: ['popular'] },
  { id: 'st02', name: 'Chicken Tikka', category: 'Starters / Appetizers', pricePerPlate: 55, isVeg: false, description: 'Smoky tandoori tikka', tags: ['popular', 'spicy'] },
  { id: 'st03', name: 'Paneer Tikka', category: 'Starters / Appetizers', pricePerPlate: 52, isVeg: true, description: 'Charred malai paneer cubes', tags: ['popular'] },
  { id: 'st04', name: 'Hara Bhara Kabab', category: 'Starters / Appetizers', pricePerPlate: 42, isVeg: true, description: 'Spinach & potato patties', tags: ['jain'] },
  { id: 'st05', name: 'Khaman Dhokla', category: 'Starters / Appetizers', pricePerPlate: 32, isVeg: true, description: 'Steamed gram flour cake', tags: ['jain'] },
  { id: 'st06', name: 'Corn Cheese Balls', category: 'Starters / Appetizers', pricePerPlate: 40, isVeg: true, description: 'Golden fried with cheese', tags: ['popular'] },
  { id: 'st07', name: 'Amritsari Fish Fry', category: 'Starters / Appetizers', pricePerPlate: 68, isVeg: false, description: 'Ajwain-marinated fried fish', tags: ['spicy'] },
  { id: 'st08', name: 'Veg Seekh Kabab', category: 'Starters / Appetizers', pricePerPlate: 38, isVeg: true, description: 'Minced veg skewers', tags: [] },
  { id: 'st09', name: 'Mushroom Galouti', category: 'Starters / Appetizers', pricePerPlate: 48, isVeg: true, description: 'Lucknow-style melt patty', tags: [] },
  { id: 'st10', name: 'Prawn Koliwada', category: 'Starters / Appetizers', pricePerPlate: 78, isVeg: false, description: 'Crispy spiced prawns', tags: ['spicy'] },
  // Soups
  { id: 'so01', name: 'Tomato Dhaniya Shorba', category: 'Soups', pricePerPlate: 28, isVeg: true, description: 'Light tomato coriander broth', tags: [] },
  { id: 'so02', name: 'Sweet Corn Soup', category: 'Soups', pricePerPlate: 26, isVeg: true, description: 'Creamy sweet corn', tags: ['popular'] },
  { id: 'so03', name: 'Hot & Sour Veg', category: 'Soups', pricePerPlate: 30, isVeg: true, description: 'Indo-Chinese style', tags: ['spicy'] },
  { id: 'so04', name: 'Mulligatawny', category: 'Soups', pricePerPlate: 36, isVeg: false, description: 'South Indian lentil soup', tags: [] },
  // Main veg
  { id: 'mv01', name: 'Paneer Butter Masala', category: 'Main Course (Veg)', pricePerPlate: 48, isVeg: true, description: 'Rich tomato butter gravy', tags: ['popular'] },
  { id: 'mv02', name: 'Palak Paneer', category: 'Main Course (Veg)', pricePerPlate: 45, isVeg: true, description: 'Spinach & cottage cheese', tags: [] },
  { id: 'mv03', name: 'Veg Kolhapuri', category: 'Main Course (Veg)', pricePerPlate: 40, isVeg: true, description: 'Spicy mixed veg', tags: ['spicy'] },
  { id: 'mv04', name: 'Dal Makhani', category: 'Main Course (Veg)', pricePerPlate: 35, isVeg: true, description: 'Slow-cooked black lentils', tags: ['popular'] },
  { id: 'mv05', name: 'Kadhai Paneer', category: 'Main Course (Veg)', pricePerPlate: 46, isVeg: true, description: 'Capsicum onion kadhai masala', tags: [] },
  { id: 'mv06', name: 'Malai Kofta', category: 'Main Course (Veg)', pricePerPlate: 42, isVeg: true, description: 'Creamy nut gravy kofta', tags: [] },
  { id: 'mv07', name: 'Bhindi Masala', category: 'Main Course (Veg)', pricePerPlate: 32, isVeg: true, description: 'Okra onion tomato', tags: [] },
  { id: 'mv08', name: 'Dum Aloo Kashmiri', category: 'Main Course (Veg)', pricePerPlate: 38, isVeg: true, description: 'Baby potato yogurt gravy', tags: [] },
  // Main non-veg
  { id: 'nv01', name: 'Butter Chicken', category: 'Main Course (Non-Veg)', pricePerPlate: 72, isVeg: false, description: 'Makhani gravy classic', tags: ['popular'] },
  { id: 'nv02', name: 'Chicken Curry', category: 'Main Course (Non-Veg)', pricePerPlate: 55, isVeg: false, description: 'Homestyle onion tomato', tags: [] },
  { id: 'nv03', name: 'Mutton Rogan Josh', category: 'Main Course (Non-Veg)', pricePerPlate: 98, isVeg: false, description: 'Kashmiri slow-cooked mutton', tags: ['popular'] },
  { id: 'nv04', name: 'Fish Curry', category: 'Main Course (Non-Veg)', pricePerPlate: 68, isVeg: false, description: 'Coastal coconut-tamarind', tags: [] },
  { id: 'nv05', name: 'Egg Curry', category: 'Main Course (Non-Veg)', pricePerPlate: 42, isVeg: false, description: 'Boiled egg masala', tags: [] },
  { id: 'nv06', name: 'Keema Matar', category: 'Main Course (Non-Veg)', pricePerPlate: 58, isVeg: false, description: 'Minced mutton with peas', tags: [] },
  { id: 'nv07', name: 'Prawn Masala', category: 'Main Course (Non-Veg)', pricePerPlate: 88, isVeg: false, description: 'Coastal onion tomato prawn', tags: ['spicy'] },
  { id: 'nv08', name: 'Lucknowi Chicken Korma', category: 'Main Course (Non-Veg)', pricePerPlate: 76, isVeg: false, description: 'Mild cashew yogurt gravy', tags: [] },
  // Breads / rice / biryani
  { id: 'br01', name: 'Butter Naan', category: 'Breads / Rice / Biryani', pricePerPlate: 22, isVeg: true, description: 'Tandoor naan brushed butter', tags: ['popular'] },
  { id: 'br02', name: 'Garlic Naan', category: 'Breads / Rice / Biryani', pricePerPlate: 28, isVeg: true, description: 'Roasted garlic topping', tags: ['popular'] },
  { id: 'br03', name: 'Lachha Paratha', category: 'Breads / Rice / Biryani', pricePerPlate: 26, isVeg: true, description: 'Flaky layered paratha', tags: [] },
  { id: 'br04', name: 'Tandoori Roti', category: 'Breads / Rice / Biryani', pricePerPlate: 15, isVeg: true, description: 'Whole wheat tandoor roti', tags: [] },
  { id: 'br05', name: 'Jeera Rice', category: 'Breads / Rice / Biryani', pricePerPlate: 26, isVeg: true, description: 'Cumin tempered basmati', tags: [] },
  { id: 'br06', name: 'Veg Pulao', category: 'Breads / Rice / Biryani', pricePerPlate: 32, isVeg: true, description: 'Garden veg pulao', tags: [] },
  { id: 'br07', name: 'Hyderabadi Veg Dum Biryani', category: 'Breads / Rice / Biryani', pricePerPlate: 55, isVeg: true, description: 'Layered dum with raita', tags: ['popular'] },
  { id: 'br08', name: 'Hyderabadi Chicken Dum Biryani', category: 'Breads / Rice / Biryani', pricePerPlate: 80, isVeg: false, description: 'Served with salan', tags: ['popular', 'spicy'] },
  // Accompaniments
  { id: 'ac01', name: 'Green Salad', category: 'Accompaniments', pricePerPlate: 18, isVeg: true, description: 'Fresh cucumber onion tomato', tags: [] },
  { id: 'ac02', name: 'Mixed Pickle', category: 'Accompaniments', pricePerPlate: 10, isVeg: true, description: 'Seasonal pickle medley', tags: [] },
  { id: 'ac03', name: 'Masala Papad', category: 'Accompaniments', pricePerPlate: 8, isVeg: true, description: 'Roasted papad with toppings', tags: ['jain'] },
  { id: 'ac04', name: 'Boondi Raita', category: 'Accompaniments', pricePerPlate: 15, isVeg: true, description: 'Chilled yogurt boondi', tags: [] },
  { id: 'ac05', name: 'Cucumber Raita', category: 'Accompaniments', pricePerPlate: 12, isVeg: true, description: 'Cooling side', tags: [] },
  { id: 'ac06', name: 'Mint Coriander Chutney', category: 'Accompaniments', pricePerPlate: 8, isVeg: true, description: 'Fresh chutney portion', tags: [] },
  // Desserts
  { id: 'ds01', name: 'Rasmalai (2 pcs)', category: 'Desserts', pricePerPlate: 35, isVeg: true, description: 'Saffron milk discs', tags: ['popular'] },
  { id: 'ds02', name: 'Gulab Jamun (2 pcs)', category: 'Desserts', pricePerPlate: 18, isVeg: true, description: 'Warm rose syrup', tags: ['popular', 'jain'] },
  { id: 'ds03', name: 'Moong Dal Halwa', category: 'Desserts', pricePerPlate: 40, isVeg: true, description: 'Ghee-roasted lentil halwa', tags: [] },
  { id: 'ds04', name: 'Ice Cream Cup', category: 'Desserts', pricePerPlate: 25, isVeg: true, description: 'Vanilla / chocolate', tags: [] },
  // Beverages
  { id: 'bv01', name: 'Welcome Sherbet', category: 'Beverages / Welcome Drinks', pricePerPlate: 20, isVeg: true, description: 'Rose or khus chilled', tags: [] },
  { id: 'bv02', name: 'Fresh Lime Soda', category: 'Beverages / Welcome Drinks', pricePerPlate: 15, isVeg: true, description: 'Sweet / salt / mix', tags: ['popular'] },
  { id: 'bv03', name: 'Masala Chaas', category: 'Beverages / Welcome Drinks', pricePerPlate: 12, isVeg: true, description: 'Spiced buttermilk', tags: [] },
  { id: 'bv04', name: 'South Filter Coffee', category: 'Beverages / Welcome Drinks', pricePerPlate: 18, isVeg: true, description: 'Traditional decoction', tags: [] },
  // Live counters
  { id: 'lc01', name: 'Pav Bhaji Live Counter', category: 'Live Counters', pricePerPlate: 45, isVeg: true, description: 'Bhaji with butter pav', tags: ['popular'] },
  { id: 'lc02', name: 'Chaat Counter', category: 'Live Counters', pricePerPlate: 42, isVeg: true, description: 'Pani puri, sev puri, dahi', tags: ['popular'] },
  { id: 'lc03', name: 'Dosa Live Station', category: 'Live Counters', pricePerPlate: 48, isVeg: true, description: 'Masala dosa & chutney', tags: [] },
  { id: 'lc04', name: 'Pasta Live Counter', category: 'Live Counters', pricePerPlate: 55, isVeg: true, description: 'Pink / arrabbiata', tags: [] },
  { id: 'lc05', name: 'BBQ Grill Counter', category: 'Live Counters', pricePerPlate: 95, isVeg: false, description: 'Assorted grills', tags: ['spicy'] },
  { id: 'lc06', name: 'Dessert Live Counter', category: 'Live Counters', pricePerPlate: 65, isVeg: true, description: 'Jalebi rabdi, kulfi', tags: ['popular'] }
];

export const ITEM_BY_ID = Object.fromEntries(FOOD_ITEMS.map((i) => [i.id, i]));

/** Curated packages — sums are approximate “per plate” targets */
export const PACKAGE_PRESETS = {
  silver: {
    key: 'silver',
    label: 'Silver Package',
    tagline: 'From ~₹299 / plate',
    blurb: 'Veg-forward essentials — great for daytime functions.',
    itemIds: ['st05', 'st08', 'so01', 'mv04', 'mv07', 'br04', 'br05', 'ac03', 'ac05', 'ds02', 'bv03']
  },
  gold: {
    key: 'gold',
    label: 'Gold Package',
    tagline: 'From ~₹449 / plate',
    blurb: 'Adds crowd favourites, biryani & richer mains.',
    itemIds: [
      'st01',
      'st03',
      'so02',
      'mv01',
      'mv04',
      'mv05',
      'nv02',
      'br02',
      'br07',
      'br08',
      'ac01',
      'ac04',
      'ds01',
      'bv02',
      'bv04'
    ]
  },
  platinum: {
    key: 'platinum',
    label: 'Platinum Package',
    tagline: 'From ~₹649 / plate',
    blurb: 'Premium mains, biryani & live counter add-on.',
    itemIds: [
      'st02',
      'st09',
      'st10',
      'so04',
      'mv01',
      'mv05',
      'nv01',
      'nv03',
      'nv07',
      'br02',
      'br08',
      'br07',
      'ac01',
      'ac04',
      'ds01',
      'ds03',
      'bv01',
      'lc01',
      'lc05'
    ]
  }
};

export const OCCASIONS = [
  { value: 'wedding', label: 'Wedding' },
  { value: 'birthday', label: 'Birthday Party' },
  { value: 'corporate', label: 'Corporate Event' },
  { value: 'engagement', label: 'Engagement / Roka' },
  { value: 'baby', label: 'Baby Shower' },
  { value: 'pooja', label: 'Pooja / Religious Function' },
  { value: 'custom', label: 'Custom' }
];

/** Suggested add-ons when user taps “Apply occasion ideas” */
export const OCCASION_SUGGESTIONS = {
  wedding: ['st03', 'mv01', 'nv01', 'br08', 'ds01', 'bv01', 'lc06'],
  birthday: ['st06', 'so02', 'mv06', 'nv02', 'br02', 'ds04', 'bv02', 'lc02'],
  corporate: ['st01', 'so01', 'mv04', 'mv05', 'br05', 'br06', 'ac01', 'bv03'],
  engagement: ['st03', 'st09', 'mv01', 'nv08', 'br07', 'ds01', 'bv01'],
  baby: ['st05', 'so02', 'mv02', 'mv06', 'br05', 'ds02', 'bv02'],
  pooja: ['st04', 'st05', 'mv07', 'mv08', 'br04', 'ac03', 'ac05', 'ds02', 'bv03'],
  custom: []
};

export function sumPerPlateForIds(ids) {
  return ids.reduce((sum, id) => sum + (ITEM_BY_ID[id]?.pricePerPlate || 0), 0);
}

export function getItemsByCategory(category) {
  return FOOD_ITEMS.filter((i) => i.category === category);
}
